export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";